export enum AddressType {
	owner = 1,
	installer = 2,
	editor = 3
}